/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Accounts/view.blocks to change it.
import AccountChooser from './AccountChooser/index'
import ContinueAction from './ContinueAction/index'
import PreferredCheckbox from './PreferredCheckbox/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Accounts({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/CreateIteroScanRequest/Content/Content/Step/Account/Content/Accounts"
  
}) {
  return (<React.Fragment
>
<AccountChooser
  viewPath={`${viewPath}/AccountChooser`}
/>
<PreferredCheckbox
  viewPath={`${viewPath}/PreferredCheckbox`}
/>
<ContinueAction
  viewPath={`${viewPath}/ContinueAction`}
/>
{children}
</React.Fragment>)
}